import React, { useState} from "react";
import { Link } from "react-router-dom";
import BixianLogo from '../assets/logos/BixianLogo.png'
// import './SideNav.css'
export default function SideNav() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrolled = window.scrollY > 5;
  //     setIsScrolled(scrolled);
  //   };
  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <div
      className={`side-nav ${isOpen ? "open" : "close"} `}
    >
      <button className="menu-btn" onClick={toggleNav}>
        <span className="material-symbols-outlined">menu</span>
      </button>
      <button className="close-btn" onClick={toggleNav}>
        <span className="material-symbols-outlined">close</span>
      </button>
      <Link className="link" to='/'><img src={BixianLogo} alt="logo" className="mobile-view-logo" /></Link>
      <ul className="side-nav-list">
        <li className="side-nav-item">
          <Link className="link" to="/" onClick={toggleNav}>
            Home
          </Link>
        </li>
        <li className="side-nav-item">
          <Link className="link" to="/services" onClick={toggleNav}>
            Services
          </Link>
          <ul className="sidemenu-services-list">
            <li className="sidemenu-services-list-item"><Link to='/services/socialmediamarketing'>Social Media Marketing</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/payperclickads'>Pay-per-Click Ads</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/websitedesigning'>Website Designing</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/whatsappmarketing'>WhatsApp Marketing</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/bulksms'>Bulk SMS</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/videoads'>Video Ads</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/searchengineoptimization'>Search Enging Optimization</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/emailmarketing'>Email Marketing</Link></li>
            <li className="sidemenu-services-list-item"><Link to='/services/influencermarketing'>Influencer Marketing</Link></li>
          </ul>
        </li>
        <li className="side-nav-item">
          <Link className="link" to="/blog" onClick={toggleNav}>
            Blog
          </Link>
        </li>
        <li className="side-nav-item">
          <Link className="link" to="/about" onClick={toggleNav}>
            About Us
          </Link>
        </li>
        <li className="side-nav-item">
          <Link className="link" to="/contact" onClick={toggleNav}>
            Contact Us
          </Link>
        </li>
        <li className="side-nav-item">
          <Link className="link" to="/careers" onClick={toggleNav}>
            Careers
          </Link>
        </li>
      </ul>
    </div>
  );
}
